module.exports = __webpack_public_path__ + "static/media/thumb_video.44dcb7a1.svg";